// extracted by mini-css-extract-plugin
export default {"root":"root___nhNSH","block":"block___DhEZi"};